export const MPARTICLE_LOCAL_STORAGE_NAMESPACE = 'mprtcl-v4';

export function getMParticleLocalStorage(item = null) {
  const getItem = (key) => {
    return localStorage.getItem(encodeURIComponent(key));
  };

  try {
    const mParticleLocalStorageKey = Object.keys(localStorage).find((key) =>
      key.startsWith(MPARTICLE_LOCAL_STORAGE_NAMESPACE),
    );

    if (mParticleLocalStorageKey) {
      const dataString = getItem(mParticleLocalStorageKey);
      if (!dataString) return null;

      const mParticleData = JSON.parse(dataString.replace(/\|/g, ',').replace(/'/g, '"'));

      return item ? mParticleData?.gs?.[item] : mParticleData;
    }
  } catch {
    return null;
  }
}
